import React from 'react'
import './assess.css'
const Categories = ({categories, filterTests}) => {
  return (
    <div className='d-flex gap-4 ps-3 mt-5'>
      {
        categories.map((category,index) => {
            return(
                <button type='button' className='test-btn' key={index} onClick={() => filterTests(category)}>{category}
                </button>
            )
        })
      }
    </div>
  )
}

export default Categories
